import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const linkedInExperienceSchema = z.object({
  title: z.string().min(1).max(100),
  company: z.string().min(1).max(100),
  description: z.string().min(1).max(2000),
});

export const linkedInReviewSchema = z.object({
  headline: z.string().min(1).max(220),
  about: z.string().min(1).max(2600),
  experiences: z.array(linkedInExperienceSchema).min(1),
  targetRole: z.string().max(500).optional(),
});

export class LinkedInReviewDto extends createZodDto(linkedInReviewSchema) {}

export type LinkedInReviewInput = z.infer<typeof linkedInReviewSchema>;
export type LinkedInExperience = z.infer<typeof linkedInExperienceSchema>;
